<template>
  <div>
    <anamnesis
      v-bind="{
        ...schema,
        modelSlides,
        handleEvents,
        save,
        snackbar,
        overlay,
        overlayMessage,
        toggleOverlay,
        status,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Anamnesis from '@/components/includes/Anamnesis';

export default {
  name: 'CAxCExSpecificCondPage',
  components: { Anamnesis },

  data: () => ({
    overlay: false,
    overlayMessage: '',
  }),

  computed: {
    ...mapGetters('anamCAxCExSpecificCond', [
      'schema',
      'modelSlides',
      'specificConditionId',
      'isNewRecord',
      'status',
    ]),
    ...mapGetters('anamPermissions', ['hasPermission']),
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions('anamCAxCExSpecificCond', [
      'fetchSchema',
      'fetchRecords',
      'createRecord',
      'updateRecord',
    ]),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },
    
    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    async save() {
      try {
        const hierarchyDisorder = { ...this.modelSlides[1].modelForm.group2 };
        const modelSlides = {
          ...this.modelSlides[0].modelForm.group1,
          ...this.modelSlides[0].modelForm.group2,
          ...this.modelSlides[1].modelForm.group1,
          hierarchyDisorder,
        };

        const specificConditionId = this.specificConditionId;

        const model = { modelSlides, specificConditionId };
        const action = this.isNewRecord ? 'createRecord' : 'updateRecord';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    handleEvents() {},

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>

<style>
.placeholderColor input::placeholder {
  color: #616161 !important;
}
</style>
